import{PriceAmount} from "./dollarPriceStyle" 

const DollarPrice = ({ donationAmount, formik }: any) => {
  const amount = donationAmount.find((donation: any) => donation.amount === formik.values.amount);

  return (
    <>
      {donationAmount?.map((donationAmountData: any, index: number) => {
        let className = "";

        if (formik.values.amount === donationAmountData?.amount || donationAmountData?.amount === "" && !amount) {
          className = "active";
        } 

        return (
          <PriceAmount 
            key={index + 1} 
            className={className} 
            onClick={() => formik.setFieldValue('amount', donationAmountData?.amount)}
          >
            {donationAmountData?.value}
          </PriceAmount>
        );
      })}
    </>
  );
};


export default DollarPrice;
